import apimgrs from './allApi/apimgrs';
import apies from './allApi/apies';
import apicase from './allApi/apicase';
import apibidmain from './allApi/apibidmain';
import apidivison from './allApi/apidivison';
import apipocx from './allApi/apipocx';
import apipocxpj from './allApi/apipocxpj';
import apisc from './allApi/apisc';
import apicalendar from './allApi/apicalendar';
import apianalysis from './allApi/apianalysis';
import apihottags from './allApi/apihottags';
import watermark from './allApi/watermark';
import apitags from './allApi/apitags';
import apidata from './allApi/apidata';
import apiannoun from './allApi/apiannoun';
export default {  apimgrs, apies, apicase, apibidmain, apidivison,apipocx, apipocxpj, apisc ,apicalendar, apianalysis, apihottags, watermark, apitags, apidata, apiannoun};